import React from 'react';
import { RadioChangeEvent } from 'antd/lib';

import { SendCommunicationFirstStepForm } from 'types';
import Card from 'components/molecules/card';

import { ConflictsTarget, Container, OthersCheckbox, Props, PurchaseTimeTarget, TypologiesTarget } from './utils';

const TargetOtherSelection = ({
  formik,
  typologies,
  conflictTypes,
  onTouch,
  checkOthers,
  setCheckOthers,
  isOnlyConflictedTickets,
  setIsOnlyConflictedTickets,
  isExcludeConflictedTickets,
  setIsExcludeConflictedTickets,
  isVisible,
}: Props) => {
  const handleCheckOthers = (e: RadioChangeEvent) => {
    onTouch();
    setCheckOthers(e.target.value);
    if (e.target.value === false) {
      setIsOnlyConflictedTickets(false);
      setIsExcludeConflictedTickets(false);
      formik.setFieldValue('selectedTypologiesIds', []);
      formik.setFieldValue('selectedConflictTypeId', null);
      formik.setFieldValue('excludeAllConflictTypes', false);
      formik.setFieldValue('selectedPurchaseComparison', null);
      formik.setFieldValue('purchaseReferenceDate', null);
      formik.setFieldValue('purchaseReferenceTime', null);
    }
  };

  const handleSelectTypologies = (ids: number[]) => {
    onTouch();
    formik.setFieldValue('selectedTypologiesIds', ids);
  };

  const handleCheckOnlyConflictedTickets = (e: RadioChangeEvent) => {
    setIsOnlyConflictedTickets(e.target.checked);
    if (!e.target.checked) {
      formik.setFieldValue('selectedConflictTypeId', null);
    }
    onTouch();

    formik.setFieldValue('excludeAllConflictTypes', false);
  };

  const handleCheckExcludeConflictedTickets = (e: RadioChangeEvent) => {
    setIsExcludeConflictedTickets(e.target.checked);
    onTouch();

    formik.setFieldValue('excludeAllConflictTypes', e.target.checked);
  };

  const handleSelectConflictType = (id: number) => {
    formik.setFieldValue('selectedConflictTypeId', id ? id : null);
    onTouch();
  };

  const handleSelectPurchase = (id: SendCommunicationFirstStepForm['selectedPurchaseComparison']) => {
    if (id) {
      formik.setFieldValue('selectedPurchaseComparison', id);
    } else {
      formik.setFieldValue('selectedPurchaseComparison', null);
      formik.setFieldValue('purchaseReferenceDate', null);
      formik.setFieldValue('purchaseReferenceTime', null);
    }
    onTouch();
  };

  const handleSelectPurchaseDate = (date: string) => {
    formik.setFieldValue('purchaseReferenceDate', date);
    onTouch();
  };

  const handleSelectPurchaseTime = (time: string) => {
    formik.setFieldValue('purchaseReferenceTime', time);
    onTouch();
  };

  return (
    <Container isVisible={isVisible}>
      <Card full margin="0px">
        <OthersCheckbox checkOthers={checkOthers} handleCheckOthers={handleCheckOthers} />

        {checkOthers && (
          <>
            <TypologiesTarget
              typologies={typologies}
              selectedTypologiesIds={formik.values.selectedTypologiesIds}
              onSelectTypologies={handleSelectTypologies}
            />

            <ConflictsTarget
              formik={formik}
              conflictTypes={conflictTypes}
              isOnlyConflictedTickets={isOnlyConflictedTickets}
              handleOnlyConflictedTickets={handleCheckOnlyConflictedTickets}
              isExcludeConflictedTickets={isExcludeConflictedTickets}
              handleExcludeConflictedTickets={handleCheckExcludeConflictedTickets}
              selectedConflictTypeId={formik.values.selectedConflictTypeId}
              onSelectConflictType={handleSelectConflictType}
            />

            <PurchaseTimeTarget
              formik={formik}
              selectedPurchaseComparison={formik.values.selectedPurchaseComparison}
              onSelectPurchase={handleSelectPurchase}
              selectedPurchaseDate={formik.values.purchaseReferenceDate}
              onSelectPurchaseDate={handleSelectPurchaseDate}
              selectedPurchaseTime={formik.values.purchaseReferenceTime}
              onSelectPurchaseTime={handleSelectPurchaseTime}
            />
          </>
        )}
      </Card>
    </Container>
  );
};

export default TargetOtherSelection;
